export default __webpack_public_path__ + "static/media/Ooty2.af1644e9.jpg";